import React from 'react';
import classNames from 'classnames';
import * as DraftEditorBlock from 'draft-js/lib/DraftEditorBlock.react';
import { Prism } from 'vendors/prism';

const supportedSyntaxes = Object.keys(Prism.languages).filter(x => typeof Prism.languages[x] === 'object');

supportedSyntaxes.sort();

export class CodeBlock extends React.Component {
	render() {
		const { block, contentState, blockProps } = this.props;
		const data = block.getData();
		const syntax = data && data.get('syntax') || 'js';
		return (
			<pre className={classNames('prism-token token', `language-${syntax}`)}>
				<DraftEditorBlock {...this.props} />
			</pre>
		);
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/codeEditPlugin/CodeBlock.jsx